import React from 'react';

interface ImageSwitchProps {
  src: string;
  srcActive: string;
  alt?: string;
  active?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler;
}

const ImageSwitch: React.FC<ImageSwitchProps> = ({
  src,
  srcActive,
  alt = '',
  active = false,
  className,
  onClick = () => {}
}) => (
  <React.Fragment>
    {!active && (
      <img src={src} alt={alt} onClick={onClick} className={className} />
    )}
    {active && (
      <img src={srcActive} alt={alt} onClick={onClick} className={className} />
    )}
  </React.Fragment>
);

export default ImageSwitch;
